var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00B2FA",
    fillRule: "evenodd",
    d: "M7.866 4.714A1.825 1.825 0 0 0 6.042 6.54v5.475c0 1.008.6 1.7 1.672 1.7h.429v3.318a1.825 1.825 0 0 0 1.825 1.825h4.285a4.562 4.562 0 0 0 2.17-8.576q.111-.486.112-1.005a4.56 4.56 0 0 0-4.562-4.562zm8.558 5.567c-.375-.203-1.21-.424-2.281-.424h-3.995c-1.008 0-2.005.693-2.005 1.7v2.157h3.83c2.174 0 3.993-1.397 4.45-3.433",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63CAAB",
    d: "M6 6.54c0-1.009.858-1.826 1.866-1.826h4.107a4.562 4.562 0 0 1 4.45 5.57s-.891-.427-2.28-.427h-1.291c-.215.004-1.46.02-2.704.01c-1.142-.01-2.005.779-2.005 1.69v2.157H7.5c-.857 0-1.5-.692-1.5-1.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBel);
export default __webpack_public_path__ + "static/media/bel.f1d20c55b588d8668c18b252433168ac.svg";
export { ForwardRef as ReactComponent };